export default "__VITE_ASSET__D$ADPWb3__"